

































































































































































































import { Component, Vue } from 'vue-property-decorator';


import { Device, Info } from '@/types/core';
import { DateTime } from 'luxon';
import { curCoreClient, CoreClient, EnrolDevReq } from '@/services/CoreClient';

import GroupAccessEdit from '@/components/access/GroupAccessEdit.vue';
import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { EnrolUtil } from '@/util/EnrolUtil';


@Component({
  components: {
    Loading,
    VueError,
    SectionHeader,
    Success,
    GroupAccessEdit
  },
})
export default class EnrolDevice extends Vue {

  // our model
  info:Info = {} as Info;

  userError:string = '';
  enrolError:string = '';
  enrolSuccess:string = '';
  
  // our model
  dateTime = DateTime;
  deviceEui:string = "";
  deviceName:string = "";
  deviceType:string = "";
  enterpriseId:string = "";
  deviceClass:'A'|'C' = 'A';
  enrolmentMode:'otaa'|'abp' = "otaa";
  // otaa
  appEui:string = "";
  appKey:string = "";
  nwAddressOtaa:string = "";
  // abp
  nwKey:string = "";
  nwAddressAbp:string = "";
  appSKey:string = "";
  
  private enrolUtil:EnrolUtil = new EnrolUtil();
  
  httpBusy:boolean = false;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  
  async mounted() {

    const reply = await this.coreClient.getInfo();

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.userError = `Unable to retrieve user info: ${reply.errorMsg}`;
    
    // we update the state
    let info = reply.info as Info;

    if(info.entIdList.length === 0) {
      return this.userError = `your user doesn't have access to this functionality`;
    }

    this.info = info;
    //console.log(`Info: ${this.info.entIdList.length} enterprises`);
  }

  get canEnrolDevice():boolean {
    return !this.httpBusy;
  }

  get canCancel():boolean {
    return !this.httpBusy;
  }

  get showLoadingUser():boolean {
    return !this.info.user && this.info.entIdList && this.info.entIdList.length > 0;
  }

  get entList():object[] {

    if(!this.info.level)
      return [];

    return this.enrolUtil.formatEntList(this.info.entIdList);
  }

  get deviceTypeList():string[] {

    if (this.info){
      return this.info.deviceTypes.sort()
    }
    return []
  }

  async enrolDevice(multiple:boolean) {

    this.httpBusy = true;

    // we clear out the previous values
    this.enrolError = '';
    this.enrolSuccess = '';
    
    let enrolDevReq:EnrolDevReq = {
      deviceId: this.deviceEui,
      enterpriseId: this.enterpriseId,
      deviceType: this.deviceType !== "" ? this.deviceType : undefined,
      name: this.deviceName,
      enrolment: {
        class: this.deviceClass,
        mode: this.enrolmentMode
      }
    }

    if(this.enrolmentMode === 'otaa')
      enrolDevReq.enrolment.otaa = {
        appEui: this.appEui,
        appKey: this.appKey,
        nwAddress: this.nwAddressOtaa !== "" ? this.nwAddressOtaa : undefined
      }
    else
      enrolDevReq.enrolment.abp = {
        nwKey: this.nwKey,
        nwAddress: this.nwAddressAbp,
        appSKey: this.appSKey !== "" ? this.appSKey : undefined
      }
      
    // try and enrol
    const reply = await this.coreClient.enrolDevice(enrolDevReq);

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.enrolError = `unable to enrol device: ${reply.errorMsg}`;

    this.setSuccess(`Device ${reply.newDevice!.deviceId} enrolled successfully`, !multiple);

  }

  setSuccess(str:string, redirect:boolean) {
    
    this.enrolSuccess = str;
    
    if(redirect)
      setTimeout(() => this.$emit('cancel'), 1000);
  }

  
  cancel() {
    this.$emit('cancel');
  }
}
